import { render, staticRenderFns } from "./CharacterModal.vue?vue&type=template&id=0cfba8a5&"
import script from "./CharacterModal.vue?vue&type=script&lang=js&"
export * from "./CharacterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports